module.exports = __webpack_public_path__ + "img/bsale_extractor.040d497c.png";